import { useMemo } from "react";

import { useTypedSelector } from "../hooks";

export const useUrl = (): URL => {
  const state = useTypedSelector(({ url }) => url);
  const url = useMemo(() => new URL(state), [state]);
  return url;
};
